import { render, staticRenderFns } from "./AFAS_3_Code_Legends.vue?vue&type=template&id=275ef536&"
import script from "./AFAS_3_Code_Legends.vue?vue&type=script&lang=js&"
export * from "./AFAS_3_Code_Legends.vue?vue&type=script&lang=js&"
import style0 from "./AFAS_3_Code_Legends.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports